import {getSearchList} from '../api/getSearchList';
import {setGetSearchListAction} from '../action';

const setGetSearchList = (params) => {
    return async (dispatch, getState) => {
        try {
            const {data} = await getSearchList(params);

            if (data.status === 'success') {
                dispatch(setGetSearchListAction({
                    data: data.data,
                    countPage: data.countPage
                }));           
            }
          
        } catch(error) {
            if (error && error.response && error.response.status === 401) {
                localStorage.removeItem('token');
                window.location.replace(window.location.origin);
            }
        }
    }
}

export {
    setGetSearchList
}